import { z } from 'zod';

export function pickZodObjectFields(
  schema: z.ZodObject<any>,
  fieldNames: string[]
): z.ZodObject<z.ZodRawShape> {
  const shape = schema.shape as Record<string, z.ZodTypeAny>;
  const pickedShape: Record<string, z.ZodTypeAny> = {};

  for (const name of fieldNames) {
    if (Object.hasOwn(shape, name)) {
      pickedShape[name] = shape[name];
    }
  }

  return z.object(pickedShape);
}
